import React, { useState } from 'react';
import { createBlockCustomFeature } from './communitySiteUtils';

const AddBlockCustomFeatureModal = ({ onAdd, onClose }) => {
  const [name, setName] = useState('');
  const [count, setCount] = useState(1);

  const handleSubmit = e => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onAdd(createBlockCustomFeature(trimmed, count));
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="delete-confirmation-modal community-custom-feature-modal"
        onClick={e => e.stopPropagation()}
      >
        <h3>Add Custom Feature</h3>
        <p className="community-custom-feature-modal-desc">
          For infrastructure not listed above — service lift, garbage chute, etc.
        </p>
        <form onSubmit={handleSubmit}>
          <label className="community-field community-field--compact">
            <span>Feature Name</span>
            <input
              type="text"
              placeholder="e.g. Service Lift, Fire Exit"
              value={name}
              onChange={e => setName(e.target.value)}
              autoFocus
            />
          </label>
          <div className="community-advanced-stepper">
            <span className="community-advanced-label">Count</span>
            <div className="community-stepper-controls">
              <button
                type="button"
                disabled={count <= 1}
                onClick={() => setCount(c => Math.max(1, c - 1))}
              >
                −
              </button>
              <span>{count}</span>
              <button
                type="button"
                disabled={count >= 50}
                onClick={() => setCount(c => Math.min(50, c + 1))}
              >
                +
              </button>
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="cancel-button" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="save-geofence-button"
              disabled={!name.trim()}
            >
              Add Feature
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBlockCustomFeatureModal;
